import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationWIDSearchInput } from '../../../../types/schema/utils.types';
import { Proposal } from '../../../../types/schema/proposal.types';

interface GetAllProposalsByRefIdBySearchHook {
  data: Proposal[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllProposalsByRefIdBySearch: Proposal[];
    }>
  >;
}

interface GetAllProposalsByRefIdBySearchMutationData {
  getAllProposalsByRefIdBySearch: Proposal[];
}

interface GetAllProposalsByRefIdBySearchInputType {
  input: PaginationWIDSearchInput;
}

export function useGetAllProposalsByRefIdBySearch(
  query: DocumentNode,
  input: PaginationWIDSearchInput
): GetAllProposalsByRefIdBySearchHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllProposalsByRefIdBySearchMutationData,
    GetAllProposalsByRefIdBySearchInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllProposalsByRefIdBySearch,
    loading,
    error,
    refetch,
  };
}
